import { createVNode, render } from 'vue';
import utils from '../../utils';
import Loading from './index.vue';
export default {
    install(app) {
        let vm = null;
        let isLoading = true;
        const container = document.createElement('div');
        app.config.globalProperties.$showLoading = () => {
            if (!isLoading) {
                return;
            }
            if (!vm) {
                vm = createVNode(Loading);
            }
            isLoading = false;
            render(vm, container);
            document.body.appendChild(container);
            container.addEventListener('touchmove', e => {
                e.stopPropagation();
            }, utils.isPassive() ? { passive: true } : false);
        };
        app.config.globalProperties.$hideLoading = () => {
            if (vm && !isLoading) {
                container.parentNode && container.parentNode.removeChild(container);
                isLoading = true;
            }
        };
    }
};
